import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Badge } from '@restworld/ui-ds-base';

import { restaurantDetailsAtom, ShowcaseSectionTitle } from '.';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IVenueBenefitsProps {}

const VenueBenefits: React.FunctionComponent<IVenueBenefitsProps> = (props) => {
  const { t } = useTranslation('restaurant-showcase-v2');
  const restaurantDetails = useAtomValue(restaurantDetailsAtom);

  if (!restaurantDetails?.benefits?.length && !restaurantDetails?.otherBenefits) return null;
  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
      <ShowcaseSectionTitle title={t('benefit')} />
      {!!restaurantDetails?.benefits && (
        <div className="self-stretch inline-flex justify-start items-start gap-4 flex-wrap content-start">
          {restaurantDetails?.benefits?.map((benefit, index) => (
            <Badge key={index} variant="neutral">
              {benefit}
            </Badge>
          ))}
        </div>
      )}
      {!!restaurantDetails?.otherBenefits && (
        <h5 className="self-stretch justify-start text-base font-normal text-neutral-700">
          {restaurantDetails.otherBenefits}
        </h5>
      )}
    </div>
  );
};

export default VenueBenefits;
